import React, { useState } from 'react';
import { ContactForm } from './ContactForm';
import './ContactForm.css';
import Meta from './Meta'; 
import ipImage from './assets/ip.jpg';

const overlayStyle = {
  position: 'fixed',
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  backgroundColor: 'rgba(0,0,0,0.5)',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  zIndex: 1000,
};

const modalStyle = {
  position: 'relative',
  backgroundColor: '#fff',
  borderRadius: '8px',
  padding: '30px 40px 40px',
  maxWidth: '600px',
  width: '90%',
  boxShadow: '0 4px 15px rgba(0,0,0,0.2)',
};

export default function StaticheskyIliDinamycheskyIp() {
  const [modalOpen, setModalOpen] = useState(false);

  const openModal = () => setModalOpen(true);
  const closeModal = () => setModalOpen(false);

   return (
       <React.Fragment>
    <Meta
    title="Статический IP или динамический: что выбрать для видеонаблюдения, игр и удаленной работы"
    description="«Чем отличается статический IP от динамического? Подробный гайд для выбора: когда нужен белый статический IP-адрес для камер, игрового сервера, удаленного доступа. Объясняем просто."
    />

    <div
    style={{
            fontFamily: "'Helvetica Neue', Helvetica, Arial, sans-serif",
            maxWidth: '900px',
            margin: '0 auto',
            padding: '40px 20px',
            lineHeight: 1.6,
            backgroundColor: '#f9f9f9',
            color: '#333',
            }}
    >
        <h1
    style={{
    textAlign: 'center',
    marginBottom: '30px',
    color: '#2c3e50',
    }}
    >
    Статический IP или динамический: что нужно для видеонаблюдения, игр и удаленной работы?
    </h1>
        <p style={{ float: 'right', maxWidth: '40%', marginLeft: '20px', marginBottom: '10px' }}>
                 <img src={ipImage} alt="Internet Illustration" style={{ width: '100%', height: 'auto' }} />
            </p>
    <p>
    Выбирая тариф интернета или настраивая роутер, вы могли видеть опцию «статический IP-адрес» за дополнительную плату. У многих возникает вопрос: «А оно мне надо?». Действительно, в 95% случаев для обычного серфинга, соцсетей и видео хватает обычного динамического IP. Но для некоторых задач этот выбор становится критически важным.</p>
    <p>
    Давайте разберемся просто, без сложных терминов: что такое статический и динамический IP, и в каких сценариях без «статики» не обойтись.
    </p>
    
    <h2
        style={{
        textAlign: 'center',
        marginBottom: '30px',
        color: '#2c3e50',
        }}
    >Простая аналогия: IP-адрес — это ваш «номер дома» в интернете</h2>
    <p>Представьте, что интернет — это огромный город.</p>
    <ul>
    <li><strong>Динамический IP</strong> — это как номер в гостинице. Каждый раз, когда вы подключаетесь к сети (перезагружаете роутер), вам выдают новый свободный «номер» из пула провайдера. Для почты и прогулок по городу (просмотр сайтов) этого достаточно.</li>
    <li><strong>Статический (белый) IP-адрес</strong> — это ваш постоянный адрес, приватный дом. Он закреплен только за вашим подключением и не меняется. К вам всегда можно обратиться по одному и тому же адресу.</li>
    </ul>
    <p>А теперь главный вопрос: когда вам нужен собственный постоянный «дом» в интернете?</p>
    
    <h2
        style={{
        textAlign: 'center',
        marginBottom: '30px',
        color: '#2c3e50',
        }}
    >Сценарий 1: Организация системы видеонаблюдения с удаленным доступом</h2>
    <p><strong>Проблема:</strong> Вы установили IP-камеры дома или на даче и хотите смотреть трансляцию со смартфона из любого места. Или хотите организовать удаленный доступ к системе видеорегистратору (NVR).</p>

    <ul>
    <li><strong>С динамическим IP:</strong> После перезагрузки роутера адрес изменится. Специальное ПО или приложение для камер потеряет с ним связь. Решение — использование облачных сервисов камер (которые часто имеют подписку) или сложная настройка DDNS (динамического DNS), которая не всегда стабильна.</li>
    <li><strong>Со статическим IP:</strong> Вы настраиваете проброс портов на роутере один раз, прописываете в приложении свой постоянный адрес, и получаете прямой и надежный доступ к камерам 24/7. Это профессиональный, безопасный и независимый от сторонних сервисов подход.</li>
    <li><strong>Вывод:</strong> Для полноценной автономной системы IP-видеонаблюдения с прямым доступом статический IP практически обязателен.</li>
    </ul>
    
    
    
   <h2
        style={{
        textAlign: 'center',
        marginBottom: '30px',
        color: '#2c3e50',
        }}
    >Сценарий 2: Хостинг игровых серверов (Minecraft, Counter-Strike и др.) или использование P2P-сетей</h2>
    <p><strong>Проблема:</strong> Вы хотите создать свой сервер для игры с друзьями, не полагаясь на сторонние хостинги.</p>
    <ul>
    <li><strong>С динамическим IP:</strong> Ваши друзья не смогут подключиться к вам, так как адрес сервера будет постоянно «уплывать». Сообщать новый IP после каждого обрыва связи — нереально.</li>
    <li><strong>Со статическим IP:</strong> Вы даете друзьям один и тот же адрес (например, 123.123.123.123:25565 для Minecraft). Сервер всегда доступен по этому адресу. Это также критично для некоторых торрент-клиентов или peer-to-peer технологий для лучшей связности.</li>
    <li><strong>Вывод:</strong> Чтобы пригласить друзей на свой игровой сервер, вам нужен статический белый IP.</li>
    </ul>
    
    <h2
        style={{
        textAlign: 'center',
        marginBottom: '30px',
        color: '#2c3e50',
        }}
    >Сценарий 3: Удаленная работа и доступ к домашним или рабочим сетям</h2>
    <p><strong>Проблема:</strong> Вам нужен безопасный доступ к рабочему компьютеру дома, NAS-серверу с файлами, корпоративной 1С-базе или системе «умный дом» из любой точки мира.</p>
    <ul>
    <li><strong>С динамическим IP:</strong> Организовать прямое VPN-подключение (например, через WireGuard или OpenVPN) к вашей домашней сети будет крайне сложно из-за меняющегося адреса.</li>
    <li><strong>Со статическим IP:</strong> Вы настраиваете VPN-сервер на своем роутере или ПК один раз. Теперь, подключаясь к своему постоянному IP, вы оказываетесь <strong>внутри своей домашней сети</strong>, как будто сидите за домашним компьютером. Это безопасно и удобно для системных администраторов, программистов и удаленных сотрудников.</li>
    <li><strong>Вывод:</strong> Для организации собственного VPN и безопасного удаленного доступа к ресурсам сети статический IP — это основа.</li>
    </ul>
    <h2
        style={{
        textAlign: 'center',
        marginBottom: '30px',
        color: '#2c3e50',
        }}
    >Сценарий 4: Повышение репутации и надежности для бизнеса</h2>
    <p>Почтовые сервера, FTP-сервера для обмена файлами с клиентами, API для интеграций — все эти услуги требуют постоянного адреса. Динамический IP может попасть в «черные списки» из-за действий предыдущего пользователя, что вызовет проблемы с доставкой почты.</p>
    
    <h2
        style={{
        textAlign: 'center',
        marginBottom: '30px',
        color: '#2c3e50',
        }}
    >Технические нюансы: «Белый» и «Серый» IP. Это важно!</h2>
    <p>Здесь кроется ключевой момент, который важно уточнить у провайдера.</p>
    <ul>
    <li><strong>Белый (публичный) IP-адрес</strong> — это уникальный адрес в глобальном интернете. К нему можно обратиться из любой точки сети. Именно он нужен для всех задач выше.</li>
    <li><strong>Серый (частный) IP-адрес в составе CG-NAT</strong> — многие провайдеры для экономики адресов помещают абонентов в общую сеть (Carrier-Grade NAT). У вас может быть статический адрес внутри сети провайдера, но извне (из интернета) к вам нельзя будет подключиться напрямую. Это сводит на нет все преимущества.</li>
    </ul>
    
    <p>Всегда задавайте вопрос: «Статический IP, который вы предлагаете, — это белый публичный адрес?»</p>
    
    <h2
        style={{
        textAlign: 'center',
        marginBottom: '30px',
        color: '#2c3e50',
        }}
    >Как подключить статический белый IP-адрес от «ИТ Особа»?</h2>
    <p>Если после прочтения вы поняли, что вашим задачам нужна статика, то оставьте заявку или позвоните нам</p>
    
    
    <div style={{ textAlign: 'center', marginTop: '40px' }}>
        <button
          onClick={openModal}
          style={{
            backgroundColor: '#2980b9',
            color: '#fff',
            border: 'none',
            borderRadius: '6px',
            padding: '14px 30px',
            fontSize: '1.1em',
            fontWeight: '600',
            cursor: 'pointer',
            transition: 'background-color 0.3s',
          }}
          onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = '#2471a3')}
          onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = '#2980b9')}
        >
          Оставить заявку
        </button>
      </div>

      {modalOpen && (
        <div style={overlayStyle} onClick={closeModal} role="dialog" aria-modal="true" aria-labelledby="modal-title">
          <div style={modalStyle} onClick={(e) => e.stopPropagation()}>
            <div
              style={{
                position: 'absolute',
                top: 12,
                right: 12,
                width: 32,
                height: 32,
                cursor: 'pointer',
                borderRadius: '50%',
                backgroundColor: '#f0f0f0',
                color: '#333',
                fontSize: 24,
                fontWeight: 'bold',
                lineHeight: '32px',
                textAlign: 'center',
                boxShadow: '0 2px 6px rgba(0,0,0,0.15)',
                transition: 'background-color 0.3s, color 0.3s, box-shadow 0.3s',
                userSelect: 'none',
              }}
              onClick={closeModal}
              aria-label="Закрыть"
              onMouseEnter={(e) => {
                e.currentTarget.style.backgroundColor = '#e0e0e0';
                e.currentTarget.style.color = '#000';
                e.currentTarget.style.boxShadow = '0 4px 8px rgba(0,0,0,0.2)';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.backgroundColor = '#f0f0f0';
                e.currentTarget.style.color = '#333';
                e.currentTarget.style.boxShadow = '0 2px 6px rgba(0,0,0,0.15)';
              }}
              onMouseDown={(e) => {
                e.currentTarget.style.backgroundColor = '#d0d0d0';
                e.currentTarget.style.boxShadow = 'inset 0 2px 4px rgba(0,0,0,0.2)';
              }}
              onMouseUp={(e) => {
                e.currentTarget.style.backgroundColor = '#e0e0e0';
                e.currentTarget.style.boxShadow = '0 4px 8px rgba(0,0,0,0.2)';
              }}
            >
              ×
            </div>
            <ContactForm />
          </div>
        </div>
      )}
      </div>

    </React.Fragment>
  );
}